export default "__VITE_ASSET__QPJyE97W__"